/* tslint:disable */
/* eslint-disable */
/**
 * YubiEnterprise SSO API
 * This YubiEnterprise SSO API allows configuration/enablement of SSO for an organization.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorDetail\'
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * The message explaining the detailed error in text.
     * @type {string}
     * @memberof ErrorDetail
     */
    'message': string;
    /**
     * json path to the field, if the error detail refers to a field
     * @type {string}
     * @memberof ErrorDetail
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     * @deprecated
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ErrorDetailAllOf
 */
export interface ErrorDetailAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailAllOf
     * @deprecated
     */
    'description'?: string;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ErrorDetailResult
 */
export interface ErrorDetailResult {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ErrorDetailResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ErrorDetailResult
     */
    'errors'?: Array<StandardErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailResult
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorDetailResult
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * To be replaced by \'#/components/schemas/StandardErrorDetail\'
     * @type {Array<ErrorDetail>}
     * @memberof ErrorDetailResult
     * @deprecated
     */
    'errorCauses'?: Array<ErrorDetail>;
}
/**
 * 
 * @export
 * @interface ErrorDetailResultAllOf
 */
export interface ErrorDetailResultAllOf {
    /**
     * To be replaced by \'#/components/schemas/StandardErrorDetail\'
     * @type {Array<ErrorDetail>}
     * @memberof ErrorDetailResultAllOf
     * @deprecated
     */
    'errorCauses'?: Array<ErrorDetail>;
}
/**
 * Deprecated: To be replaced by \'#/components/schemas/StandardErrorResult\'
 * @export
 * @interface ErrorResult
 */
export interface ErrorResult {
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof ErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof ErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResult
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * 
 * @export
 * @interface ErrorResultAllOf
 */
export interface ErrorResultAllOf {
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResultAllOf
     * @deprecated
     */
    'errorCauses'?: Array<object>;
}
/**
 * The mutable part of the SSO SAML configuration, values originate from the IdP configuration. 
 * @export
 * @interface IdPSAMLConfiguration
 */
export interface IdPSAMLConfiguration {
    /**
     * The entityID url of the IdentityProvider that the ServiceProvider will trust.  Name in Azure AD (enterprise app): Azure AD Identifier 
     * @type {string}
     * @memberof IdPSAMLConfiguration
     */
    'idp_entity_id': string;
    /**
     * The SAML Single Sign On Service Endpoint. The login url of the IdentityProvider where the user-agent is directed to perform the actual login. Name in Azure AD (enterprise app): Login URL 
     * @type {string}
     * @memberof IdPSAMLConfiguration
     */
    'single_sign_on_service_location': string;
    /**
     * The X509 certificate issued by the IdentityProvider that the ServiceProvider trusts when validating the SAMLResponse signature.  Name in Azure AD (enterprise app): Certificate (Base64) 
     * @type {string}
     * @memberof IdPSAMLConfiguration
     */
    'idp_signing_certificate': string;
}
/**
 * 
 * @export
 * @interface SAMLConfigurationPatchRequest
 */
export interface SAMLConfigurationPatchRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SAMLConfigurationPatchRequest
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface SAMLConfigurationResponse
 */
export interface SAMLConfigurationResponse {
    /**
     * Id of the configuration. This value is readonly. The configuration id is part of the path when updating a configuration. 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'configuration_id': string;
    /**
     * The url represents the ServiceProvider entityID that the IdentityProvider is configured to accept login requests from. This value is readonly, and is required information to configure the IdentityProvider. Name in Azure AD (enterprise app): Identifier (Entity ID) 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'sp_entity_id': string;
    /**
     * The url to initiate the ServiceProvider initiated login flow. This value is readonly, and is required information for users to initiate service login with SSO. 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'sp_login_url': string;
    /**
     * The SAML Assertion Consumer Service Endpoint. The endpoint url of the ServiceProvider that the IdentityProvider should redirect the user agent to. This value is readonly, and is required information to configure the IdentityProvider. Name in Azure AD (enterprise app): Reply URL (Assertion Consumer Service URL) 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'assertion_consumer_service_location': string;
    /**
     * Indicates the state of the configuration. When enabled, SSO login may be initiated by the user agent by visiting the {sp_login_url}. 
     * @type {boolean}
     * @memberof SAMLConfigurationResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'modified_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'created_at': string;
    /**
     * 
     * @type {IdPSAMLConfiguration}
     * @memberof SAMLConfigurationResponse
     */
    'idp_configuration': IdPSAMLConfiguration;
    /**
     * Indicates if IdP Initiated SSO is allowed. When allowed, SSO login may be initiated from the Identity Provider. 
     * @type {boolean}
     * @memberof SAMLConfigurationResponse
     */
    'idp_initiated_allowed': boolean | null;
    /**
     * Link that IdP Initiated SSO should post its saml payload to. 
     * @type {string}
     * @memberof SAMLConfigurationResponse
     */
    'idp_initiated_link': string | null;
}
/**
 * 
 * @export
 * @interface SAMLConfigurationUpdateRequest
 */
export interface SAMLConfigurationUpdateRequest {
    /**
     * 
     * @type {IdPSAMLConfiguration}
     * @memberof SAMLConfigurationUpdateRequest
     */
    'idp_configuration': IdPSAMLConfiguration;
    /**
     * Indicates if IdP Initiated SSO is allowed. When allowed, SSO login may be initiated from the Identity Provider. 
     * @type {boolean}
     * @memberof SAMLConfigurationUpdateRequest
     */
    'idp_initiated_allowed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface StandardErrorDetail
 */
export interface StandardErrorDetail {
    /**
     * The message explaining the detailed error in text.
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'message': string;
    /**
     * json path to the field, if the error detail refers to a field
     * @type {string}
     * @memberof StandardErrorDetail
     */
    'field'?: string;
}
/**
 * 
 * @export
 * @interface StandardErrorResult
 */
export interface StandardErrorResult {
    /**
     * 
     * @type {string}
     * @memberof StandardErrorResult
     */
    'code': string;
    /**
     * The error message in text
     * @type {string}
     * @memberof StandardErrorResult
     */
    'message'?: string;
    /**
     * A list of details of each distinct problem encountered. Omitted when empty
     * @type {Array<StandardErrorDetail>}
     * @memberof StandardErrorResult
     */
    'errors'?: Array<StandardErrorDetail>;
}

/**
 * SamlConfigurationApi - axios parameter creator
 * @export
 */
export const SamlConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create SAML configuration of organization
         * @summary Create SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSAMLConfiguration: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/sso/protocols/saml/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable / disable SAML configuration of organization
         * @summary Enable / disable SAML configuration of organization
         * @param {string} configurationId Id of the configuration
         * @param {SAMLConfigurationPatchRequest} [sAMLConfigurationPatchRequest] Enable / disable SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableSAMLConfiguration: async (configurationId: string, sAMLConfigurationPatchRequest?: SAMLConfigurationPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('enableSAMLConfiguration', 'configurationId', configurationId)
            const localVarPath = `/v1/sso/protocols/saml/config/{configuration_id}`
                .replace(`{${"configuration_id"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sAMLConfigurationPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all SAML configurations of organization. Currently there will be at most one entry in the list, but this may change.
         * @summary Get all SAML configurations of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSAMLConfigurations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/sso/protocols/saml/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get SAML configuration of organization by Id
         * @summary Get SAML configuration of organization by Id
         * @param {string} configurationId Id of the configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSAMLConfigurationById: async (configurationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('getSAMLConfigurationById', 'configurationId', configurationId)
            const localVarPath = `/v1/sso/protocols/saml/config/{configuration_id}`
                .replace(`{${"configuration_id"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update SAML configuration of organization by Id
         * @summary Update SAML configuration of organization by Id
         * @param {string} configurationId Id of the configuration
         * @param {SAMLConfigurationUpdateRequest} [sAMLConfigurationUpdateRequest] add complete record of SSO SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSAMLConfigurationById: async (configurationId: string, sAMLConfigurationUpdateRequest?: SAMLConfigurationUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('updateSAMLConfigurationById', 'configurationId', configurationId)
            const localVarPath = `/v1/sso/protocols/saml/config/{configuration_id}`
                .replace(`{${"configuration_id"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sAMLConfigurationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SamlConfigurationApi - functional programming interface
 * @export
 */
export const SamlConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SamlConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Create SAML configuration of organization
         * @summary Create SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSAMLConfiguration(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SAMLConfigurationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSAMLConfiguration(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable / disable SAML configuration of organization
         * @summary Enable / disable SAML configuration of organization
         * @param {string} configurationId Id of the configuration
         * @param {SAMLConfigurationPatchRequest} [sAMLConfigurationPatchRequest] Enable / disable SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableSAMLConfiguration(configurationId: string, sAMLConfigurationPatchRequest?: SAMLConfigurationPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableSAMLConfiguration(configurationId, sAMLConfigurationPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all SAML configurations of organization. Currently there will be at most one entry in the list, but this may change.
         * @summary Get all SAML configurations of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSAMLConfigurations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SAMLConfigurationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSAMLConfigurations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get SAML configuration of organization by Id
         * @summary Get SAML configuration of organization by Id
         * @param {string} configurationId Id of the configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSAMLConfigurationById(configurationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SAMLConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSAMLConfigurationById(configurationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update SAML configuration of organization by Id
         * @summary Update SAML configuration of organization by Id
         * @param {string} configurationId Id of the configuration
         * @param {SAMLConfigurationUpdateRequest} [sAMLConfigurationUpdateRequest] add complete record of SSO SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSAMLConfigurationById(configurationId: string, sAMLConfigurationUpdateRequest?: SAMLConfigurationUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SAMLConfigurationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSAMLConfigurationById(configurationId, sAMLConfigurationUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SamlConfigurationApi - factory interface
 * @export
 */
export const SamlConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SamlConfigurationApiFp(configuration)
    return {
        /**
         * Create SAML configuration of organization
         * @summary Create SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSAMLConfiguration(options?: any): AxiosPromise<Array<SAMLConfigurationResponse>> {
            return localVarFp.createSAMLConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * Enable / disable SAML configuration of organization
         * @summary Enable / disable SAML configuration of organization
         * @param {string} configurationId Id of the configuration
         * @param {SAMLConfigurationPatchRequest} [sAMLConfigurationPatchRequest] Enable / disable SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableSAMLConfiguration(configurationId: string, sAMLConfigurationPatchRequest?: SAMLConfigurationPatchRequest, options?: any): AxiosPromise<void> {
            return localVarFp.enableSAMLConfiguration(configurationId, sAMLConfigurationPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all SAML configurations of organization. Currently there will be at most one entry in the list, but this may change.
         * @summary Get all SAML configurations of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSAMLConfigurations(options?: any): AxiosPromise<Array<SAMLConfigurationResponse>> {
            return localVarFp.getAllSAMLConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * Get SAML configuration of organization by Id
         * @summary Get SAML configuration of organization by Id
         * @param {string} configurationId Id of the configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSAMLConfigurationById(configurationId: string, options?: any): AxiosPromise<SAMLConfigurationResponse> {
            return localVarFp.getSAMLConfigurationById(configurationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update SAML configuration of organization by Id
         * @summary Update SAML configuration of organization by Id
         * @param {string} configurationId Id of the configuration
         * @param {SAMLConfigurationUpdateRequest} [sAMLConfigurationUpdateRequest] add complete record of SSO SAML configuration of organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSAMLConfigurationById(configurationId: string, sAMLConfigurationUpdateRequest?: SAMLConfigurationUpdateRequest, options?: any): AxiosPromise<Array<SAMLConfigurationResponse>> {
            return localVarFp.updateSAMLConfigurationById(configurationId, sAMLConfigurationUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SamlConfigurationApi - object-oriented interface
 * @export
 * @class SamlConfigurationApi
 * @extends {BaseAPI}
 */
export class SamlConfigurationApi extends BaseAPI {
    /**
     * Create SAML configuration of organization
     * @summary Create SAML configuration of organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlConfigurationApi
     */
    public createSAMLConfiguration(options?: AxiosRequestConfig) {
        return SamlConfigurationApiFp(this.configuration).createSAMLConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable / disable SAML configuration of organization
     * @summary Enable / disable SAML configuration of organization
     * @param {string} configurationId Id of the configuration
     * @param {SAMLConfigurationPatchRequest} [sAMLConfigurationPatchRequest] Enable / disable SAML configuration of organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlConfigurationApi
     */
    public enableSAMLConfiguration(configurationId: string, sAMLConfigurationPatchRequest?: SAMLConfigurationPatchRequest, options?: AxiosRequestConfig) {
        return SamlConfigurationApiFp(this.configuration).enableSAMLConfiguration(configurationId, sAMLConfigurationPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all SAML configurations of organization. Currently there will be at most one entry in the list, but this may change.
     * @summary Get all SAML configurations of organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlConfigurationApi
     */
    public getAllSAMLConfigurations(options?: AxiosRequestConfig) {
        return SamlConfigurationApiFp(this.configuration).getAllSAMLConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get SAML configuration of organization by Id
     * @summary Get SAML configuration of organization by Id
     * @param {string} configurationId Id of the configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlConfigurationApi
     */
    public getSAMLConfigurationById(configurationId: string, options?: AxiosRequestConfig) {
        return SamlConfigurationApiFp(this.configuration).getSAMLConfigurationById(configurationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update SAML configuration of organization by Id
     * @summary Update SAML configuration of organization by Id
     * @param {string} configurationId Id of the configuration
     * @param {SAMLConfigurationUpdateRequest} [sAMLConfigurationUpdateRequest] add complete record of SSO SAML configuration of organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamlConfigurationApi
     */
    public updateSAMLConfigurationById(configurationId: string, sAMLConfigurationUpdateRequest?: SAMLConfigurationUpdateRequest, options?: AxiosRequestConfig) {
        return SamlConfigurationApiFp(this.configuration).updateSAMLConfigurationById(configurationId, sAMLConfigurationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


